import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const IndexPage = lazy(() => import('src/pages/reports/reportsGeneral'));
const ExpiringPassportsPage = lazy(() => import('src/pages/reports/expiring-passports'));
const ClientTransactionsPage = lazy(() => import('src/pages/reports/clientTransactions'));

export const reportsRoutes = [
  {
    path: 'reports',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      { path: 'client-transactions', element: <ClientTransactionsPage /> },
      { path: 'expiring-passports', element: <ExpiringPassportsPage /> },
    ],
  },
];
